import SwitchUserErrorContent from '../components/switchUserError'

const SwitchUserError = () => {
  return (
    <>
      <SwitchUserErrorContent />
    </>
  )
}

export default SwitchUserError
